import {useUserDetails as coreUseUserDetails} from '@sollapay/web-core';

import {config} from '@/app';

export function useUserDetails() {
  return coreUseUserDetails(config.auth0.claimsNamespace);
}
